<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Buttons</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Examples</h5>
              <p>Bootstrap includes several predefined button styles, each serving its own semantic purpose, with a few
                extras thrown in for more control.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <button type="button" class="btn btn-primary">Primary</button>
                  <button type="button" class="btn btn-secondary ml-1">Secondary</button>
                  <button type="button" class="btn btn-success ml-1">Success</button>
                  <button type="button" class="btn btn-danger ml-1">Danger</button>
                  <button type="button" class="btn btn-warning ml-1">Warning</button>
                  <button type="button" class="btn btn-info ml-1">Info</button>
                  <button type="button" class="btn btn-light ml-1">Light</button>
                  <button type="button" class="btn btn-dark ml-1">Dark</button>
                  <button type="button" class="btn btn-link ml-1">Link</button>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;button type=&quot;button&quot; class=&quot;btn btn-primary&quot;&gt;Primary&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;Secondary&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-success&quot;&gt;Success&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-danger&quot;&gt;Danger&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-warning&quot;&gt;Warning&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-info&quot;&gt;Info&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-light&quot;&gt;Light&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-dark&quot;&gt;Dark&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-link&quot;&gt;Link&lt;/button&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Button tags</h5>
              <p>The <code class="text-danger">.btn</code> classes are designed to be used with the <code
                  class="text-danger">&lt;button&gt;</code> element. However, you can also use these classes on <code
                  class="text-danger">&lt;a&gt;</code> or <code class="text-danger">&lt;input&gt;</code> elements
                (though
                some browsers may apply a slightly different rendering).</p>
              <p>When using button classes on <code class="text-danger">&lt;a&gt;</code> elements that are used to
                trigger
                in-page functionality (like collapsing content), rather than linking to new pages or sections within the
                current page, these links should be given a <code class="text-danger">role="button"</code> to
                appropriately convey their purpose to assistive technologies such as screen readers.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <a class="btn btn-primary" href="#" role="button">Link</a>
                  <button class="btn btn-primary ml-1" type="submit">Button</button>
                  <input class="btn btn-primary ml-1" type="button" value="Input">
                  <input class="btn btn-primary ml-1" type="submit" value="Submit">
                  <input class="btn btn-primary ml-1" type="reset" value="Reset">
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;a class=&quot;btn btn-primary&quot; href=&quot;#&quot; role=&quot;button&quot;&gt;Link&lt;/a&gt;
  &lt;button class=&quot;btn btn-primary&quot; type=&quot;submit&quot;&gt;Button&lt;/button&gt;
  &lt;input class=&quot;btn btn-primary&quot; type=&quot;button&quot; value=&quot;Input&quot;&gt;
  &lt;input class=&quot;btn btn-primary&quot; type=&quot;submit&quot; value=&quot;Submit&quot;&gt;
  &lt;input class=&quot;btn btn-primary&quot; type=&quot;reset&quot; value=&quot;Reset&quot;&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Outline button</h5>
              <p>In need of a button, but not the hefty background colors they bring? Replace the default modifier
                classes
                with the <code class="text-danger">.btn-outline-*</code> ones to remove all background images and colors
                on any button.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <button type="button" class="btn btn-outline-primary">Primary</button>
                  <button type="button" class="btn btn-outline-secondary ml-1">Secondary</button>
                  <button type="button" class="btn btn-outline-success ml-1">Success</button>
                  <button type="button" class="btn btn-outline-danger ml-1">Danger</button>
                  <button type="button" class="btn btn-outline-warning ml-1">Warning</button>
                  <button type="button" class="btn btn-outline-info ml-1">Info</button>
                  <button type="button" class="btn btn-outline-light ml-1">Light</button>
                  <button type="button" class="btn btn-outline-dark ml-1">Dark</button>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;button type=&quot;button&quot; class=&quot;btn btn-outline-primary&quot;&gt;Primary&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-secondary&quot;&gt;Secondary&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-success&quot;&gt;Success&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-danger&quot;&gt;Danger&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-warning&quot;&gt;Warning&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-info&quot;&gt;Info&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-light&quot;&gt;Light&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-outline-dark&quot;&gt;Dark&lt;/button&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Button Sizes and Disabled state</h5>
              <p class="mb-1">Fancy larger or smaller buttons? Add <code class="text-danger">.btn-lg</code> or <code
                  class="text-danger">.btn-sm</code> for additional sizes.</p>
              <p class="mb-1">Create block level buttons—those that span the full width of a parent—by adding <code
                  class="text-danger">.btn-block</code>.</p>
              <p>Make buttons look inactive by adding the <code class="text-danger">disabled</code> boolean attribute to
                any <code class="text-danger">&lt;button&gt;</code> element.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <button type="button" class="btn btn-primary btn-lg">Large button</button>
                  <button type="button" class="btn btn-secondary btn-sm ml-1">Small button</button>
                  <button type="button" class="btn btn-lg btn-primary ml-1" disabled>Primary button</button>
                  <button type="button" class="btn btn-secondary btn-lg ml-1" disabled>Button</button>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;button type=&quot;button&quot; class=&quot;btn btn-primary btn-lg&quot;&gt;Large button&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary btn-sm&quot;&gt;Small button&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-primary btn-lg btn-block&quot;&gt;Block level button&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-lg btn-primary&quot; disabled&gt;Primary button&lt;/button&gt;
  &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary btn-lg&quot; disabled&gt;Button&lt;/button&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Button : Group -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Button group</h5>
              <p>Wrap a series of buttons with <code class="language-plaintext highlighter-rouge">.btn</code> in <code
                  class="language-plaintext highlighter-rouge">.btn-group</code>. Add on optional JavaScript radio and
                checkbox style behavior with <a href="#">our buttons plugin</a>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-secondary">Left</button>
                    <button type="button" class="btn btn-secondary ml-1">Middle</button>
                    <button type="button" class="btn btn-secondary ml-1">Right</button>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;btn-group&quot; role=&quot;group&quot; aria-label=&quot;Basic example&quot;&gt;
      &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;Left&lt;/button&gt;
      &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;Middle&lt;/button&gt;
      &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;Right&lt;/button&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Button toolbar</h5>
              <p>Combine sets of button groups into button toolbars for more complex components. Use utility classes as
                needed to space out groups, buttons, and more.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div class="btn-group me-2" role="group" aria-label="First group">
                      <button type="button" class="btn btn-secondary">1</button>
                      <button type="button" class="btn btn-secondary">2</button>
                      <button type="button" class="btn btn-secondary">3</button>
                      <button type="button" class="btn btn-secondary">4</button>
                    </div>
                    <div class="btn-group me-2" role="group" aria-label="Second group">
                      <button type="button" class="btn btn-secondary">5</button>
                      <button type="button" class="btn btn-secondary">6</button>
                      <button type="button" class="btn btn-secondary">7</button>
                    </div>
                    <div class="btn-group" role="group" aria-label="Third group">
                      <button type="button" class="btn btn-secondary">8</button>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;btn-toolbar&quot; role=&quot;toolbar&quot; aria-label=&quot;Toolbar with button groups&quot;&gt;
      &lt;div class=&quot;btn-group me-2&quot; role=&quot;group&quot; aria-label=&quot;First group&quot;&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;1&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;2&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;3&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;4&lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;btn-group me-2&quot; role=&quot;group&quot; aria-label=&quot;Second group&quot;&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;5&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;6&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;7&lt;/button&gt;
      &lt;/div&gt;
      &lt;div class=&quot;btn-group&quot; role=&quot;group&quot; aria-label=&quot;Third group&quot;&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;8&lt;/button&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Button Nesting</h5>
              <p>Wrap a series of buttons with <code class="language-plaintext highlighter-rouge">.btn</code> in <code
                  class="language-plaintext highlighter-rouge">.btn-group</code>. Add on optional JavaScript radio and
                checkbox style behavior with <a href="#">our buttons plugin</a>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                    <button type="button" class="btn btn-secondary">1</button>
                    <button type="button" class="btn btn-secondary">2</button>

                    <div class="btn-group" role="group" dropdown>
                      <button type="button" id="btnGroupDrop1" dropdownToggle type="button"
                        class="btn btn-secondary dropdown-toggle" aria-controls="dropdown-basic">
                        Dropdown
                      </button>
                      <div class="dropdown-menu" id="btnGroupDrop1" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-basic">
                        <a class="dropdown-item" href="#">Dropdown link</a>
                        <a class="dropdown-item" href="#">Dropdown link</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;btn-group&quot; role=&quot;group&quot; aria-label=&quot;Button group with nested dropdown&quot;&gt;
      &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;1&lt;/button&gt;
      &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot;&gt;2&lt;/button&gt;

      &lt;div class=&quot;btn-group&quot; role=&quot;group&quot;&gt;
          &lt;button id=&quot;btnGroupDrop1&quot; type=&quot;button&quot; class=&quot;btn btn-secondary dropdown-toggle&quot; data-toggle=&quot;dropdown&quot; aria-haspopup=&quot;true&quot; aria-expanded=&quot;false&quot;&gt;
              Dropdown
          &lt;/button&gt;
          &lt;div class=&quot;dropdown-menu&quot; aria-labelledby=&quot;btnGroupDrop1&quot;&gt;
              &lt;a class=&quot;dropdown-item&quot; href=&quot;#&quot;&gt;Dropdown link&lt;/a&gt;
              &lt;a class=&quot;dropdown-item&quot; href=&quot;#&quot;&gt;Dropdown link&lt;/a&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
